import React from 'react'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./customStyle.css"
import { homePageAssets } from '../../../../assets/media';


const TestimonialsCarousel = ({ images, customSettings, customStyle = '', customImgStyle = '', shuffleBy = 1 }) => {

    const {
        diamond0,
        diamond1,
        diamond2,
        diamond3,
        diamond4
    } = homePageAssets.customTestimonialAssets


    const testimonials = [
        {
            avatar: diamond0,
            testimonialKey: 0,
            name: "Jamal Nasir",
            designation: "Chief Human Resources Officer",
            companyName: "HBL",
            testimonial: "Together with The Talent Games, we have launched our Cash Officer and Relationship Manager Programs. These both programs were gamified and customised according to our organisational values. Every year we launch our Internship and Management Trainee Programs with The Talent Games. I must say, they have really changed the recruitment game for HBL."
        },
        {
            avatar: diamond1,
            testimonialKey: 1,
            name: "Nadia Kader",
            designation: "Ex Head of HR & Talent Management",
            companyName: "Grameenphone",
            testimonial: "Bulk recruitment with accurate results was our main concern. The Talent Games turned out to be our best choice to tackle that challenge. Their gamified assessment provided deep candidate insights which helped us save plenty of time in making better hiring decisions."
        },
        {
            avatar: diamond2,
            testimonialKey: 2,
            name: "Dhrub Mandal",
            designation: "Ex Regional Talent Manager",
            companyName: "Nestlé AOA",
            testimonial: "Our partnership with The Talent Games for our signature 'Nesternship Virtual Internship Program' has been phenomenal. The gamified assessments by The Talent Games helped us launch the game across the globe to engage the top talent and resulting in outstanding employer branding."
        },
        {
            avatar: diamond3,
            testimonialKey: 3,
            name: "Nhung Dinh Kim",
            designation: "Ex Head of Human Capital",
            companyName: "Masan Group",
            testimonial: "The Talent Games has completely transformed the way we recruit our talent. With their gamified tests, Masan Group managed to stand out from the crowd and position itself as an innovating employer across Vietnam."
        },
        {
            avatar: diamond4,
            testimonialKey: 4,
            name: "Rehan Naeem",
            designation: "Head of Culture, D&I",
            companyName: "Bank Alfalah Limited",
            testimonial: "A remarkable hiring solution for HR professionals. Thanks to The Talent Games, we have been hiring top talent as Interns and Management Trainees for our Bank. Our gamified tests effectively demonstrate our values and culture, giving us great employer branding opportunities."
        },

    ]

    var settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        ...customSettings
    };




    return (
        <>

            <div className={`carousel mx-auto   ${customStyle}`}>

                <Slider {...settings} >

                    {
                        testimonials.map((testimonial, index) => (

                            <div key={testimonial.testimonialKey + index} className="relative mb-5">
                                {/* <img src={img} className={` mx-auto ${customImgStyle}`} alt="" /> */}
                                {/* chat bubble new */}
                                <div className="chatBubbleCarousel mx-12 my-20  rounded-xl p-5 h-[15rem]  shadow-chatBubble flex justify-center items-center">
                                    <div className={`testimonialParagraph  text-[12px] font-semibold leading-[20px] text-center  2xl:text-[16px] 2xl:leading-[25px] transition-opacity  ease-linear duration-500 delay-150 `}>
                                        {testimonial.testimonial}
                                    </div>

                                </div>
                                {/* info section */}
                                <div className={`diamondAvatarWithInfo  ml-12 absolute bottom-0 flex items-center  transition-opacity duration-500 delay-150 `}>
                                    <div className="imgCover p-1 bg-diamondBack bg-center bg-[length:4.5rem_4.5rem]">
                                        <img src={testimonial.avatar} className="object-contain   w-[3.5rem]" alt="" />
                                    </div>
                                    <div className="info ml-5">
                                        <div className="name text-[16px] font-bold text-[#3F4941]">{testimonial.name}</div>
                                        <div className="designation text-[#7F837F] text-[12px] leading-[16px]  font-bold ">{testimonial.designation}</div>
                                        <div className="companyName text-[#FEBB12] text-[12px] leading-[16px]   font-bold">{testimonial.companyName}</div>
                                    </div>
                                </div>


                            </div>
                        ))
                    }

                </Slider>
            </div>


        </>
    )
}

export default TestimonialsCarousel